/**
 * The team screen's own catalogue: `Team`, `MemberList`, `RolePicker`,
 * `GrantAddressReader`, `InvitationList` and `InviteForm` (`InviteDialog`),
 * all in the sibling `members/`, `invitations/` and this directory. No other
 * module writes to it -- a key set shared across screens is the collision
 * `defineCatalogue` exists to avoid (see `src/app/control/panel/panel.
 * messages.ts` for the same reasoning).
 */

import { defineCatalogue } from '../../../i18n';

export const teamCatalogue = defineCatalogue(
  {
    'member.changeRole': 'Alterar acesso',
    'role.title': 'Alterar o acesso de {email}',
    'role.save': 'Salvar',
    'member.grantAddress': 'Conceder leitura de endereços',
    'member.remove': 'Remover da organização',
    'member.actions': 'Ações do membro',
    'members.empty': 'Ninguém além de você ainda',
    'invitations.empty': 'Nenhum convite pendente',
    'remove.title': 'Remover {email}?',
    'remove.confirm': 'Remover',
    'revoke.title': 'Revogar o convite de {email}?',
    'revoke.confirm': 'Revogar',
    'grant.title': 'Conceder leitura de endereços a {email}?',
    'grant.confirm': 'Conceder',
    'members.you': 'você',
    'invite.scope.label': 'Escopo',
    'invite.scope.tenantWide': 'Toda a organização',
    'invite.expired': 'Expirado',
  },
  {
    'member.changeRole': 'Change access',
    'role.title': "Change {email}'s access",
    'role.save': 'Save',
    'member.grantAddress': 'Grant address reading',
    'member.remove': 'Remove from organisation',
    'member.actions': 'Member actions',
    'members.empty': 'Nobody but you yet',
    'invitations.empty': 'No pending invitations',
    'remove.title': 'Remove {email}?',
    'remove.confirm': 'Remove',
    'revoke.title': 'Revoke the invitation for {email}?',
    'revoke.confirm': 'Revoke',
    'grant.title': 'Grant address reading to {email}?',
    'grant.confirm': 'Grant',
    'members.you': 'you',
    'invite.scope.label': 'Scope',
    'invite.scope.tenantWide': 'Whole organisation',
    'invite.expired': 'Expired',
  },
);

export const tm = teamCatalogue.t;
